import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { ConfirmationHierarchyMessage } from '../../messages/ConfirmationHierarchyMessage';
import { ConfirmationSummaryMessage } from '../../messages/ConfirmationSummaryMessage';
import { ListSelectMessage } from '../../messages/ListSelectMessage';
import { ListSelectMultiMessage } from '../../messages/ListSelectMultiMessage';
import { NumberedListMessage } from '../../messages/NumberedListMessage/NumberedListMessage';
import { SimpleConfirmationMessage } from '../../messages/SimpleConfirmationMessage';
import styles from './DecisionSlot.module.scss';
export const GetDecisionSlotTID = (parentTestId)=>getTestIds(parentTestId);
const renderActiveCard = (message, handlers)=>{
    const content = message.content;
    switch(content.type){
        case 'simple-confirmation':
            return /*#__PURE__*/ _jsx(SimpleConfirmationMessage, {
                content: content,
                messageId: message.id,
                interactive: true,
                onDismiss: handlers.onDismissProposal,
                onApply: handlers.onApplyProposal
            });
        case 'confirmation-summary':
            return /*#__PURE__*/ _jsx(ConfirmationSummaryMessage, {
                content: content,
                messageId: message.id,
                interactive: true,
                onDismiss: handlers.onDismissProposal,
                onApply: handlers.onApplyProposal
            });
        case 'confirmation-hierarchy':
            return /*#__PURE__*/ _jsx(ConfirmationHierarchyMessage, {
                content: content,
                messageId: message.id,
                interactive: true,
                onDismiss: handlers.onDismissProposal,
                onApply: handlers.onApplyProposal
            });
        case 'list-select':
            return /*#__PURE__*/ _jsx(ListSelectMessage, {
                content: content,
                messageId: message.id,
                onListSelectClick: handlers.onListSelectClick
            });
        case 'list-select-multi':
            return /*#__PURE__*/ _jsx(ListSelectMultiMessage, {
                content: content,
                messageId: message.id,
                interactive: true,
                onDismiss: handlers.onDismissProposal,
                onApply: handlers.onApplyProposal
            });
        case 'numbered-list':
            return /*#__PURE__*/ _jsx(NumberedListMessage, {
                content: content,
                messageId: message.id,
                onOptionClick: handlers.onNumberedListClick
            });
        default:
            return null;
    }
};
export const DecisionSlot = (param)=>{
    let { activeMessage, onDismissProposal, onApplyProposal, onListSelectClick, onNumberedListClick, testId } = param;
    const { DecisionSlotTestIds } = useMemo(()=>GetDecisionSlotTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys();
    return /*#__PURE__*/ _jsx(AnimatePresence, {
        initial: false,
        children: activeMessage != null && /*#__PURE__*/ _jsx(motion.div, {
            "data-testid": DecisionSlotTestIds.Root(),
            className: styles.root,
            role: "region",
            "aria-label": t.agenticDrafting.body.decisionSlotLabel(),
            "aria-live": "polite",
            initial: {
                opacity: 0,
                height: 0
            },
            animate: {
                opacity: 1,
                height: 'auto',
                transition: {
                    duration: 0.42,
                    ease: [
                        0.32,
                        0.72,
                        0,
                        1
                    ]
                }
            },
            exit: {
                opacity: 0,
                height: 0,
                transition: {
                    duration: 0.32,
                    ease: [
                        0.32,
                        0.72,
                        0,
                        1
                    ]
                }
            },
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.cardWrapper,
                children: renderActiveCard(activeMessage, {
                    onDismissProposal,
                    onApplyProposal,
                    onListSelectClick,
                    onNumberedListClick
                })
            })
        })
    });
};
